import React from 'react'
import Skeleton from 'components/Skeleton'
const replaceAll = (str, find, replace) => {
  return str.split(find).join(replace)
}

export const tradeMarkSymbolParser = text => {
  if (!text.indexOf) {
    return text
  }

  const TRADEMARK_SYMBOLS = ['™', '®', '©', '℠', '℗', '🄯', 'Ⓜ']
  for (let i = 0; i <= TRADEMARK_SYMBOLS.length; i++) {
    if (text?.indexOf(TRADEMARK_SYMBOLS[i]) > -1) {
      text = replaceAll(
        text,
        TRADEMARK_SYMBOLS[i],
        `<sup>${TRADEMARK_SYMBOLS[i]}</sup>`,
      )
      // console.log('text', text)
    }
  }
  return text
}

export const titleParser = title => {
  if (!title) return title
  return tradeMarkSymbolParser(title)
}

export const TrademarkSafeTitle = ({ title }) => {
  let theTitle = titleParser(title)

  return (
    <>
      {theTitle ? (
        <span dangerouslySetInnerHTML={{ __html: titleParser(title) }} />
      ) : (
        <Skeleton count={2} />
      )}
    </>
  )
}
